import "./token.mjs";
import "ethers";
import "@deorderbook/contracts/abi";
import "../store/provider.mjs";
import "@deorderbook/contracts";
import "../store/subgraph.mjs";
import { useWETHContract as r } from "../store/wethContract.mjs";
function l(t) {
  return r().balanceOf(t);
}
function f(t, o) {
  return r().allowance(t, o);
}
function m(t, o) {
  return r(!0).approve(t, o);
}
function w() {
  return r().totalSupply();
}
function d(t) {
  return r(!0).deposit({
    value: t
  });
}
function s(t) {
  return r(!0).withdraw(t);
}
export {
  f as allowance,
  m as approve,
  l as balanceOf,
  d as deposit,
  w as totalSupply,
  s as withdraw
};
//# sourceMappingURL=token_weth.mjs.map
